

























































































import LazyHydrate from 'vue-lazy-hydration';
import {
  defineComponent,
  onMounted,
  ref,
  onUnmounted,
  useContext,
  computed,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { useUiState } from '~/composables';
import { SfImage } from '~/components/StorefrontUi';
import { throttle } from 'lodash-es';
import HeaderMenu from '~/components/MainHeader/HeaderMenu/HeaderMenu.vue';
import Logo from '~/components/MainHeader/Logo/Logo.vue';
import StaticLinks from '~/components/MainHeader/StaticLinks/StaticLinks.vue';
import SearchBar from '~/components/MainHeader/SearchBar/SearchBar.vue';
import Toolbar from '~/components/MainHeader/Toolbar/Toolbar.vue';
import Slider from '~/components/MainHeader/Slider/Slider.vue';
import { SHOP_EMAIL, SHOP_PHONE, STORE_URL } from '~/config/base';

export default defineComponent({
  name: 'MainHeader',
  components: {
    Logo,
    SearchBar,
    Toolbar,
    StaticLinks,
    HeaderMenu,
    Slider,
    SfImage,
    LazyHydrate,
    Notification: () => import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
  },
  setup() {
    const { isWishlistSidebarOpen, isCartSidebarOpen } = useUiState();
    const { i18n } = useContext();
    const isSticky = ref(false);
    const showHeaderMenu = ref(false);
    const isSearchBarVisible = ref(false);

    const handleScroll = throttle(() => {
      // window.scrollY - doesn't works on mobile
      isSticky.value = document.documentElement.scrollTop > 0 || document.body.scrollTop > 0;
    }, 100);

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    const getOrganizationSchema = () => JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      url: `${STORE_URL}`,
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: SHOP_PHONE,
          email: SHOP_EMAIL,
        },
      ],
    });

    const FELImagesSource = computed(() => {
      switch (i18n.locale) {
        case 'en':
          return {
            src: addBasePath('/images/fel-large-en.png'),
          };
        case 'pl':
          return {
            src: addBasePath('/images/fel-large.png'),
          };
        default: {
          return {
            src: addBasePath('/images/fel-large.png'),
          };
        }
      }
    });

    return {
      getOrganizationSchema,
      addBasePath,
      isSticky,
      showHeaderMenu,
      isSearchBarVisible,
      isWishlistSidebarOpen,
      isCartSidebarOpen,
      FELImagesSource,
    };
  },
});
